import { mapperModuleMedia } from '#layers/core/data-layer/modules/mappers'
import imageSizes from '../../../../core/constants/imageSizes'
import type { MapperImageOptions, MapperOptions } from '#layers/core/types'

/**
 * BlockEventSpeaker
 */

export const mapperEventSpeaker = (data: any, imageOptions: MapperImageOptions) => {
  if (!data) {
    return null
  }

  const defaultImageOptions = {
    resize: true,
    lazy: true,
    sizes: imageSizes.event_speakers
  }

  return {
    id: data.sys?.id || '',
    sys: data.sys || null,
    contentType: data.contentType,
    name: data.name || '',
    role: data.role || '',
    description: data.speakerDescription || '',
    speakerImage: mapperModuleMedia(data.speakerImage, defaultImageOptions) || null
  }
}
